import { createRequestActions } from '../../utils';
import * as draftLabelFormTypes from './draftLabelFormTypes';

export const loadForm = createRequestActions(draftLabelFormTypes.LOAD_FORM, productId => ({
  productId,
}));
